var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSortIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.18799 1.00293L0.496582 4.7749C0.350098 4.92871 0.254883 5.14844 0.254883 5.34619C0.254883 5.80029 0.569824 6.10791 1.0166 6.10791C1.23633 6.10791 1.41211 6.03467 1.55127 5.88818L3.06738 4.3208L4.04883 3.18555L3.99023 4.75293V13.9082C3.99023 14.3623 4.3125 14.6846 4.75928 14.6846C5.20605 14.6846 5.52832 14.3623 5.52832 13.9082V4.75293L5.46973 3.18555L6.4585 4.3208L7.96729 5.88818C8.10645 6.03467 8.28955 6.10791 8.50195 6.10791C8.94873 6.10791 9.26367 5.80029 9.26367 5.34619C9.26367 5.14844 9.17578 4.92871 9.02197 4.7749L5.33789 1.00293C5.01562 0.666016 4.51025 0.658691 4.18799 1.00293ZM13.812 14.4355L17.5034 10.6489C17.6499 10.5024 17.7451 10.2827 17.7451 10.085C17.7451 9.63086 17.4302 9.32324 16.9834 9.32324C16.7637 9.32324 16.5879 9.39648 16.4414 9.54297L14.9326 11.103L13.9512 12.2456L14.0098 10.6782V1.52295C14.0098 1.07617 13.6875 0.746582 13.2407 0.746582C12.7939 0.746582 12.4644 1.07617 12.4644 1.52295V10.6782L12.5229 12.2456L11.5415 11.103L10.0327 9.54297C9.88623 9.39648 9.71045 9.32324 9.49805 9.32324C9.05127 9.32324 8.73633 9.63086 8.73633 10.085C8.73633 10.2827 8.82422 10.5024 8.9707 10.6489L12.6621 14.4355C12.9844 14.7651 13.4897 14.7725 13.812 14.4355Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortIcon);
export default __webpack_public_path__ + "static/media/sort-icon.60f1db224879579cb231162889eebf8e.svg";
export { ForwardRef as ReactComponent };